import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "row mt-5 mb-lg-5" };
const _hoisted_2 = { class: "d-none d-lg-block col-lg-4" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("h1", { class: "h1 pb-0 text-truncate" }, "   ", -1);
const _hoisted_5 = [
    _hoisted_4
];
const _hoisted_6 = { class: "col-12 col-lg-8" };
const _hoisted_7 = { key: 0 };
const _hoisted_8 = { class: "pb-0 text-truncate" };
const _hoisted_9 = { class: "row pb-4" };
const _hoisted_10 = { class: "d-none d-lg-block col-lg-4" };
const _hoisted_11 = { class: "pe-2" };
const _hoisted_12 = { class: "col-12 col-lg-8 pb-3" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_breadcrumb = _resolveComponent("g-breadcrumb");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                (_ctx.pageTitle)
                    ? (_openBlock(), _createElementBlock("header", _hoisted_3, _hoisted_5))
                    : _createCommentVNode("", true),
                _createVNode(_component_g_breadcrumb, { "show-home": true })
            ]),
            _createElementVNode("div", _hoisted_6, [
                (_ctx.pageTitle)
                    ? (_openBlock(), _createElementBlock("header", _hoisted_7, [
                        _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.pageTitle), 1)
                    ]))
                    : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "title")
            ])
        ]),
        _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                    _renderSlot(_ctx.$slots, "sidebar")
                ])
            ]),
            _createElementVNode("div", _hoisted_12, [
                _renderSlot(_ctx.$slots, "content")
            ])
        ])
    ], 64));
}
